import { Component, OnInit, TemplateRef } from '@angular/core';
import { ToastService } from './toast.service';
import { MaterialModule } from '../../material/material.module';

@Component({
  selector: 'app-toasts',
  template: './toast.component.html',
  host: {'[class.ngb-toasts]': 'true'}
})
export class ToastComponent implements OnInit {

  constructor(public toastService: ToastService) { }

  isTemplate(toast) { return toast.textOrTpl instanceof TemplateRef; }

  ngOnInit() {
  }

}
